// Dev-sync options block rendered inside the BugReportButton compose area
// for platform_owner / platform_dev users. Lets the reporter route the note
// into the dev sync queue, optionally tag a target path, and attach a
// graphic asset (SVG preferred). Extracted from BugReportButton to keep
// that file under the file-size hygiene soft cap while adding the mic
// dictation button (dev sync note 816024b6).

type Props = {
  queueForDevSync: boolean;
  setQueueForDevSync: (next: boolean) => void;
  repoPath: string;
  setRepoPath: (next: string) => void;
  setGraphicFile: (next: File | null) => void;
  isOwnerSync: boolean;
  submitting: boolean;
};

export function BugReportSyncOptions({
  queueForDevSync,
  setQueueForDevSync,
  repoPath,
  setRepoPath,
  setGraphicFile,
  isOwnerSync,
  submitting,
}: Props) {
  return (
    <>
      <label className="flex items-start gap-2 rounded-lg border border-violet-200 bg-violet-50/80 px-2.5 py-2 text-[11px] text-violet-950">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={isOwnerSync ? true : queueForDevSync}
          onChange={(e) => setQueueForDevSync(e.target.checked)}
          disabled={submitting || isOwnerSync}
        />
        <span>
          <strong>Queue for dev sync</strong> —{" "}
          {isOwnerSync
            ? "platform_owner reports always go to IDE sync on the next export."
            : "Queued for platform_owner review before IDE sync. Uncheck to file a normal bug report instead."}
        </span>
      </label>
      {queueForDevSync ? (
        <div className="space-y-2 rounded-lg border border-indigo-200 bg-indigo-50/60 px-2.5 py-2 text-[11px] text-indigo-950">
          <label className="block">
            Target path (optional)
            <input
              className="mt-0.5 w-full rounded border border-indigo-200 bg-white px-2 py-1 text-xs font-mono"
              placeholder="public/ui/example.svg"
              value={repoPath}
              onChange={(e) => setRepoPath(e.target.value)}
              disabled={submitting}
            />
          </label>
          <label className="block">
            Attach graphic (SVG, PNG, WebP, or JPEG)
            <input
              type="file"
              accept=".svg,.png,.webp,.jpg,.jpeg,image/svg+xml,image/png,image/webp,image/jpeg"
              className="mt-0.5 block w-full text-xs"
              disabled={submitting}
              onChange={(e) => setGraphicFile(e.target.files?.[0] ?? null)}
            />
          </label>
        </div>
      ) : null}
    </>
  );
}
